import type { IconProps } from './types';

export function Cinto({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M32 116 Q64 114 96 116 Q96 104 96 92 Q128 90 160 92 Q160 104 160 116 Q192 114 224 116 Q224 128 224 140 Q192 142 160 140 Q160 152 160 164 Q128 166 96 164 Q96 152 96 140 Q64 142 32 140 Q32 128 32 116 Z" />
      <path d="M128 116 Q128 128 128 140" />
    </svg>
  );
}
